export default class SubscriptionPlan {
  id: number;
  price = "";
  trialDays = 0;
  interval = "";
  savingsDescription = "";

  get formattedInterval(): string {
    return `Pay per ${this.interval}`;
  }

  constructor(planId: number, savingsDescription = "") {
    this.id = planId;

    if (savingsDescription) {
      this.savingsDescription = savingsDescription;
    }
  }

  setData(data: SubscriptionPlan) {
    if (data.price) {
      this.price = data.price;
    }

    if (data.trialDays) {
      this.trialDays = data.trialDays;
    }

    if (data.interval) {
      this.interval = data.interval;
    }
  }
}
